import React from 'react';
import PropTypes from 'prop-types';

import BWModal from '../BWModal';

const BWWorkflowStepper = ({ steps, currentStep }) => (
  <nav
    className='bw_modal_workflow_stepper'
    aria-label='Tiến trình xử lý'
    style={{ '--bw-workflow-step-count': steps.length }}>
    <span className='bw_modal_workflow_mobile_progress'>
      Bước {currentStep + 1}/{steps.length}: {steps[currentStep]?.label || steps[currentStep]}
    </span>
    <ol>
      {steps.map((step, index) => {
        const label = step?.label || step;
        const isCurrent = index === currentStep;
        const isCompleted = index < currentStep;
        return (
          <li
            key={step?.key || label}
            className={
              isCurrent ? 'bw_modal_workflow_step_current' : isCompleted ? 'bw_modal_workflow_step_completed' : ''
            }
            aria-current={isCurrent ? 'step' : undefined}>
            <span className='bw_modal_workflow_step_number' aria-hidden='true'>
              {isCompleted ? <span className='fi fi-rr-check' /> : index + 1}
            </span>
            <span>{label}</span>
          </li>
        );
      })}
    </ol>
  </nav>
);

BWWorkflowStepper.propTypes = {
  steps: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({
        key: PropTypes.string,
        label: PropTypes.node.isRequired,
      }),
    ]),
  ).isRequired,
  currentStep: PropTypes.number.isRequired,
};

const BWWorkflowModal = ({
  steps,
  currentStep,
  contextSummary,
  backLabel = 'Quay lại',
  nextLabel = 'Tiếp tục',
  finishLabel = 'Hoàn tất',
  closeLabel = 'Đóng',
  onBack,
  onNext,
  onFinish,
  primaryAction,
  secondaryAction,
  cancelAction,
  children,
  ...modalProps
}) => {
  const isLastStep = currentStep === steps.length - 1;
  const resolvedPrimaryAction = primaryAction || {
    label: isLastStep ? finishLabel : nextLabel,
    onClick: isLastStep ? onFinish : onNext,
  };
  const resolvedSecondaryAction =
    secondaryAction ||
    (currentStep > 0 && onBack
      ? {
          label: backLabel,
          onClick: onBack,
        }
      : null);

  return (
    <BWModal
      {...modalProps}
      size={modalProps.size || 'xl'}
      context={
        <>
          {contextSummary ? <div className='bw_modal_workflow_summary'>{contextSummary}</div> : null}
          <BWWorkflowStepper steps={steps} currentStep={currentStep} />
        </>
      }
      cancelAction={cancelAction || { label: closeLabel }}
      secondaryAction={resolvedSecondaryAction}
      primaryAction={resolvedPrimaryAction}>
      <div className='bw_modal_workflow_body' data-current-step={currentStep + 1}>
        {children}
      </div>
    </BWModal>
  );
};

BWWorkflowModal.propTypes = {
  steps: BWWorkflowStepper.propTypes.steps,
  currentStep: PropTypes.number.isRequired,
  contextSummary: PropTypes.node,
  backLabel: PropTypes.string,
  nextLabel: PropTypes.string,
  finishLabel: PropTypes.string,
  closeLabel: PropTypes.string,
  onBack: PropTypes.func,
  onNext: PropTypes.func,
  onFinish: PropTypes.func,
  primaryAction: PropTypes.object,
  secondaryAction: PropTypes.object,
  cancelAction: PropTypes.object,
  children: PropTypes.node,
};

export default BWWorkflowModal;
